import axios, { AxiosRequestConfig } from 'axios';

const httpGet = async (url: string, config?: AxiosRequestConfig) => {
  const response = await axios.get(url, config);
  return response;
};

export default httpGet;
